module.exports = __webpack_public_path__ + "static/media/frame_29.702cc811.jpg";